/**
 * Retorna uma nova lista de talhoesFazenda com a variedade do talhão informado
 * atualizada, ou a mesma referência (sem alterações) quando não há nada a sincronizar.
 */
export function buildTalhoesComVariedadeAtualizada(talhoesFazenda, talhaoUid, variedade) {
    if (!Array.isArray(talhoesFazenda) || !talhaoUid || !variedade) return talhoesFazenda;

    const talhaoIndex = talhoesFazenda.findIndex((t) => t.uid === talhaoUid);
    if (talhaoIndex === -1) return talhoesFazenda;

    if (talhoesFazenda[talhaoIndex].variedade?.uid === variedade.uid) return talhoesFazenda;

    const novosTalhoes = talhoesFazenda.slice();
    novosTalhoes[talhaoIndex] = { ...novosTalhoes[talhaoIndex], variedade };
    return novosTalhoes;
}
